import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'src/app/core/config/configuration.service';
import { HttpParamsFromListRequestDTO, ListRequestDTO, ListResponseDTO } from '../';

@Injectable()
export class ExperimentsProxy {
    constructor(private http: HttpClient, private configurationService: ConfigurationService) {}

    async get(options: ListRequestDTO): Promise<ListResponseDTO<ExperimentSummaryDTO>> {
        const url = this.configurationService.APIURL + '/api/experiments';
        const params = HttpParamsFromListRequestDTO(options);
        return await this.http.get<ListResponseDTO<ExperimentSummaryDTO>>(url, { params: params }).toPromise();
    }

    async getDetails(id: string): Promise<ExperimentDetailsDTO> {
        const url = this.configurationService.APIURL + '/api/experiments/' + id;
        return await this.http.get<ExperimentDetailsDTO>(url).toPromise();
    }
}

export interface ExperimentSummaryDTO {
    id: string;
    createdBy: string;
    uploadDate: Date | string;
    status: ExperimentStatus;
    fileName: string;
}

export interface ExperimentDetailsDTO {
    id: string;
    createdBy: string;
    uploadDate: Date | string;
    status: ExperimentStatus;
    fileName: string;
    incompleteOrders: string[];
    invalidOrders: string[];
    completeOrders: string[];
    unknownOrders: string[];
}

export enum ExperimentStatus {
    Processing = 1,
    Failed = 2,
    Success = 3,
}
